import { apiClient } from "./api";
import { resolveApiBaseUrl, shouldEnableVitePoc } from "./config";

function bootstrapViteCore(): void {
  if (!shouldEnableVitePoc()) {
    return;
  }

  window.menushkaCoreVite = {
    config: {
      apiBaseUrl: resolveApiBaseUrl(),
    },
    api: {
      get: apiClient.get,
      post: apiClient.post,
    },
  };

  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    // Debug marker in local runs only.
    console.info("[F-11.1] Vite+TS PoC enabled", window.menushkaCoreVite.config);
  }
}

bootstrapViteCore();
